import React from "react";
import StackedBarChart from "../stackedBarChart/StackedBarChart";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getUsersByQuater } from "../../services/adminService";

const SalesStatistics = () => {
  const userId = useSelector((state) => state.auth.id);

  const {
    data: fetchUsersByQuater,
    isLoading,
    error: fetchUsersByQuaterError,
  } = useQuery({
    queryKey: ["fetchUsersByQuater"],
    queryFn: getUsersByQuater,
    enabled: !!userId,
  });

  const formattedData = fetchUsersByQuater?.map((item) => ({
    name: item.quarter,
    user: item.user || 0,
    mentor: item.mentor || 0,
  }));

  const barKeys = [
    { key: "user", color: "#4B0082" },
    { key: "mentor", color: "#FF1493" },
  ];
  
  return (
    <div className="bg-white rounded-[4px] shadow-lg p-5 flex flex-col gap-4">
      <p className="font-semibold text-base">Users Statistics</p>
      <StackedBarChart
        data={formattedData}
        xAxisKey="name"
        barKeys={barKeys}
        barSize={30}
        height={350}
      />
    </div>
  );
};

export default SalesStatistics;
